import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=4d472997&"
import script from "./RoleSelect.vue?vue&type=script&lang=ts&"
export * from "./RoleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d472997')) {
      api.createRecord('4d472997', component.options)
    } else {
      api.reload('4d472997', component.options)
    }
    module.hot.accept("./RoleSelect.vue?vue&type=template&id=4d472997&", function () {
      api.rerender('4d472997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/RoleSelect.vue"
export default component.exports